// Afrikaans translations
export const af: Record<string, string> = {
  'menu.dashboard': 'Paneelbord',
  'menu.customers': 'Kliënte',
  'menu.products': 'Produkte',
  'menu.users': 'Gebruikers',
  'menu.settings': 'Instellings',
  'menu.logout': 'Teken uit',
  'dashboard.title': 'Paneelbord',
  'dashboard.newOrder': 'Nuwe bestelling',
  'order.title': 'Nuwe bestelling',
  'order.customer': 'Kliënt',
  'order.products': 'Produkte',
  'order.total': 'Totaal',
  'users.title': 'Gebruikers',
  'users.name': 'Naam',
  'users.email': 'E-pos',
  'common.yes': 'Ja',
  'common.no': 'Nee',
  'common.cancel': 'Kanselleer',
  'common.save': 'Stoor',
  'common.search': 'Soek',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Teken in',
  'login.welcome': 'Welkom, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'E-pos',
  'signup.phone': 'Telefoon',
  'menu.reportsAndAccounting': 'Verslae & Rekeningkunde',
  'menu.systemAndCommunication': 'Stelsel & Kommunikasie',
};